import { getConfig } from '@atlassian/teams-common/context-config';

import RestClient from './rest-client';

class TeamCentralRestClient extends RestClient {
	constructor() {
		super({
			serviceUrl: `${getConfig().stargateRoot}/watermelon`,
		});
	}

	async hasWorkspaceForCloudId(cloudId: string): Promise<boolean> {
		try {
			await this.getResource(`/workspace/exists?cloudId=${cloudId}`);
			return true;
		} catch (err) {
			return false;
		}
	}

	async doesOrgContainAnyWorkspace(cloudId: string): Promise<boolean> {
		try {
			await this.getResource(`/organization/containsAnyWorkspace?cloudId=${cloudId}`);
			return true;
		} catch (err) {
			return false;
		}
	}
}

/**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default new TeamCentralRestClient();
